{
    "banner": {
        "title": "We use cookies",
        "message": "We use cookies to enhance your experience and analyze site traffic. You can accept all or keep only essential cookies.",
        "acceptAll": "Accept all",
        "rejectOptional": "Essential only",
        "preferences": "Manage preferences",
        "essentialNote": "Essential cookies are always on so the site can work (sign-in, security, language)."
    },
    "preferences": {
        "title": "Cookie preferences",
        "essential": "Essential cookies (always on)",
        "analytics": "Analytics cookies",
        "marketing": "Marketing cookies",
        "save": "Save preferences"
    }
}
